module.exports = __webpack_public_path__ + "static/media/background.b4bdae67.png";